import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useEffect } from "react";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";

// Initialize Highcharts modules
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

const PlantEfficiencyDP = ({ plantRatio }) => {
  const isValidRatio = typeof plantRatio === "number" && isFinite(plantRatio);
  const cappedNeedleValue = isValidRatio ? Math.min(plantRatio, 100) : 0;
  console.log("value is >>>", cappedNeedleValue);
  const showWarning = isValidRatio
    ? plantRatio > 60 || plantRatio < 20
    : "invalid";

  const options = {
    chart: {
      type: "gauge",
      backgroundColor: "transparent",
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: "40%",
    },

    title: { text: null },

    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ["50%", "75%"],
      size: "100%",
    },

    yAxis: {
      min: 0,
      max: 100,
      tickPosition: "inside",
      tickColor: Highcharts.defaultOptions.chart.backgroundColor || "#FFFFFF",
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        distance: 20,
        style: { fontSize: "14px" },
      },
      lineWidth: 0,
      plotBands: [
        {
          from: 20,
          to: 50,
          color: "#55BF3B", // green
          thickness: 20,
          borderRadius: "50%",
        },
        {
          from: 0,
          to: 19.99,
          color: "#DF5353", // red
          thickness: 20,
          borderRadius: "50%",
        },
        {
          from: 51,
          to: 100,
          color: "#DF5353", // red
          thickness: 20,
          borderRadius: "50%",
        },
      ],
    },

    series: [
      {
        name: "Ratio",
        data: [cappedNeedleValue],
        tooltip: {
          valueSuffix: " %",
        },
        dataLabels: {
          format:
            typeof plantRatio === "number" && isFinite(plantRatio)
              ? `${plantRatio}%`
              : "Invalid Input",
          borderWidth: 0,
          color: Highcharts.defaultOptions.title?.style?.color || "#333333",
          style: {
            fontSize: "30px",
          },
        },

        dial: {
          radius: cappedNeedleValue < 0 ? "0%" : "80%",
          backgroundColor: "gray",
          baseWidth: 9,
          baseLength: "0%",
          rearLength: "0%",
        },
        pivot: {
          radius: 10,
        },
      },
    ],

    credits: { enabled: false },
  };

  useEffect(() => {
    const chart = Highcharts.charts[0];
    if (
      chart &&
      !chart.renderer.forExport &&
      chart.series.length > 0 &&
      typeof plantRatio === "number"
    ) {
      const point = chart.series[0].points[0];
      point.update(plantRatio);
    }
  }, [plantRatio]);

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />

      <div style={{ textAlign: "center", marginTop: "10px" }}>
        {!isValidRatio ? (
          <div
            className="alert alert-danger fs-4 fw-bold py-4 px-4"
            role="alert"
          >
            <h3>
              ⚠ Efficiency value could not be calculated. Please check your
              input.
            </h3>
          </div>
        ) : showWarning ? (
          <div
            className="alert alert-warning fs-4 fw-bold py-4 px-4"
            role="alert"
          >
            <h3>
              ⚠ Warning: Efficiency value{" "}
              {plantRatio > 60 ? "exceeds" : "is below"} the optimal range.
              <br />
              Please review your input.
            </h3>
          </div>
        ) : null}

        <div className="alert alert-info fs-4 fw-bold py-4 px-4">
          <i className="fas fa-info-circle me-2" />
          <h2>
            The gauge meter represents the ratio between
            <strong> ‘F2-Production Supply / Electricity Generated’ </strong>
            and
            <strong> ‘F3-Conversion’ </strong>.
            <br />
            Ensure the product value and unit is inserted under its appropriate
            form.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default PlantEfficiencyDP;
